import {useParams} from 'react-router-dom';
import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {selectSession} from '../../auth/authSlice';

export const useUserId = () => {
  const params = useParams<{userId: string}>();
  const session = useAppSelector(selectSession);

  return Number(params.userId ?? session?.id ?? 0);
};
